import React, { useEffect, useState } from "react";
import * as Device from "expo-device";

/**
 * Represents the types of devices the application can run on.
 * @typedef {"PHONE" | "TABLET" | "DESKTOP" | "TV" | "UNKNOWN"} DeviceType
 */
export type DeviceType = "PHONE" | "TABLET" | "DESKTOP" | "TV" | "UNKNOWN";

/**
 * Enum mapping device types to their string representations.
 * Used for consistent device type labeling across the application.
 * @enum {string}
 */
export enum DeviceTypeLabels {
  PHONE = "PHONE",
  TABLET = "TABLET",
  DESKTOP = "DESKTOP",
  TV = "TV",
  UNKNOWN = "UNKNOWN",
}

/**
 * A hook that detects and provides the current device type.
 * Uses expo-device to determine if the app is running on a phone,
 * tablet, desktop, TV, or unknown device type.
 *
 * @returns {Object} An object containing the detected device type.
 * @returns {DeviceType} Object.deviceType - The detected device type.
 */
const useDeviceType = () => {
  const [deviceType, setDeviceType] = useState<DeviceType>("UNKNOWN");

  /**
   * Asynchronously determines the device type using expo-device API.
   * Updates the deviceType state once detected.
   */
  const getDeviceType = async () => {
    Device.getDeviceTypeAsync().then((d) => {
      const device = Device.DeviceType[d] as DeviceType;
      console.log("This is running on a", device);
      setDeviceType(device);
    });
  };

  useEffect(() => {
    getDeviceType();
  }, []);

  return {
    deviceType,
  };
};

export default useDeviceType;
